import React from "react";
import { css } from "emotion";
import headerShaded from "../../../src/assets/images/header-shadow2.png";
import TitleBlock from "../TitleBlock";
import TopRow from "../header/TopRow";

const CheckoutMobileHeader = () => {
  return (
    <div className={container}>
      <TopRow />
      <TitleBlock
        title="Checkout"
        subtitle="You're about to get everything you wanted"
      />
    </div>
  );
};

export default CheckoutMobileHeader;

const container = css`
  min-height: 250px;
`;
